import { createElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import Avatar from 'funifier-nice-avatar';

/** Uma camada SVG do avatar, com a posição dentro do quadrado do avatar. */
export interface CamadaDoAvatar {
  src: string;
  x: number;
  y: number;
  largura: number;
  altura: number;
}

export interface AvatarMedido {
  /** Cor de fundo do círculo do avatar. */
  fundo?: string;
  camadas: CamadaDoAvatar[];
}

/**
 * Avatar montado pronto para o canvas do cartão (PERFIL-51).
 *
 * O `funifier-nice-avatar` desenha HTML com várias camadas SVG posicionadas. Para não
 * depender de `foreignObject` (que contamina o canvas em alguns navegadores), o avatar é
 * montado fora da tela no tamanho do círculo, e cada SVG vira uma imagem com a posição
 * medida. O cartão desenha as camadas na mesma ordem, uma sobre a outra.
 */
export function medirAvatar(config: object, tamanho: number): AvatarMedido {
  const caixa = document.createElement('div');
  caixa.setAttribute('aria-hidden', 'true');
  caixa.style.cssText = `position:fixed;left:-10000px;top:0;width:${tamanho}px;height:${tamanho}px;`;
  caixa.innerHTML = renderToStaticMarkup(createElement(Avatar, { style: { width: tamanho, height: tamanho }, ...config }));
  document.body.appendChild(caixa);

  try {
    const raiz = caixa.firstElementChild as HTMLElement | null;
    const origem = caixa.getBoundingClientRect();
    const serializador = new XMLSerializer();

    const camadas = Array.from(caixa.querySelectorAll('svg')).map(svg => {
      const r = svg.getBoundingClientRect();
      // A camada ocupa uma caixa de proporção diferente da intrínseca e o navegador centraliza o
      // desenho nela ("meet"). Com o tamanho da caixa no próprio SVG, a imagem sai igual à da página.
      const copia = svg.cloneNode(true) as SVGSVGElement;
      copia.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      copia.setAttribute('width', String(r.width));
      copia.setAttribute('height', String(r.height));
      copia.removeAttribute('style');
      return {
        src: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(serializador.serializeToString(copia))}`,
        x: r.left - origem.left,
        y: r.top - origem.top,
        largura: r.width,
        altura: r.height,
      };
    });

    return { fundo: raiz?.style.background || raiz?.style.backgroundColor || undefined, camadas };
  } finally {
    caixa.remove();
  }
}
